import { createTheme, responsiveFontSizes } from '@mui/material/styles';

// Define our custom color palette
const palette = {
  primary: {
    main: '#3f51b5',
    light: '#6573c3',
    dark: '#2c387e',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#ff4081',
    light: '#ff79b0',
    dark: '#c60055',
    contrastText: '#ffffff',
  },
  error: {
    main: '#f44336',
    light: '#f6685e',
    dark: '#aa2e25',
  },
  background: {
    default: '#fafafa',
    paper: '#ffffff',
    dark: '#121212',
  },
  text: {
    primary: '#333333',
    secondary: '#666666',
    disabled: '#999999',
  },
  telegram: {
    main: '#0088cc',
    light: '#55acee',
    dark: '#005885',
  },
};

// Create the base theme
let theme = createTheme({
  palette,
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '3.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2.75rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '2.2rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h4: {
      fontSize: '1.75rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.6,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          padding: '10px 24px',
          fontWeight: 500,
        },
        containedPrimary: {
          boxShadow: '0 4px 10px rgba(63, 81, 181, 0.25)',
          '&:hover': {
            boxShadow: '0 6px 15px rgba(63, 81, 181, 0.35)',
          },
        },
        containedSecondary: {
          boxShadow: '0 4px 10px rgba(255, 64, 129, 0.25)',
          '&:hover': {
            boxShadow: '0 6px 15px rgba(255, 64, 129, 0.35)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

// Make the typography responsive
theme = responsiveFontSizes(theme);

export default theme; 